import api from "./api";

export const putMainImage = async (id) => {
  return api
    .put({
      port: process.env.REACT_APP_PORT_IMG,
      endpoint: `/own/images/venue/main/${id}`,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
